import { useContext } from "react";
import { dataContext } from "../../../context/context";
import './cases.css';


function CasesCardMobile({index}) {

    const { data, isLocal  } = useContext(dataContext);

        let urlPrefix = "/images/";
        if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;


    const section = data.sectionsdata.find(s => s.nick === 'cases');
        const paragraph = section ? section.paragraphsdata.find(p => p.nick === 'cases1') : [];

        const gal = paragraph.galerydata[index];
        const text = gal.text;

        return (

            <div className="ggalery-main__carddesktopinner">
                <div className="galery-main__carddesktopimage" style={{ backgroundImage: `url(${urlPrefix + gal.image})` }}></div>

                <div className="galery-main__text1">
                    <span className="galery-main__city">{text[0]}</span>
                    <span className="galery-main__payback">{text[1]}</span>
                    <span className="galery-main__revenue">{text[2]}</span>
                    <span className="galery-main__profit">{text[3]}</span>
                </div>

            </div>

        )

    }

export default CasesCardMobile;